$(document).ready(function(){

  function getUnits() {
    units = Number($(".fabricQuantity").val());
    if (isNaN(units)) {
      return 0;
    }
    else {
      var currentVal = $('.fabricQuantity').val() * 2;
      $('#ProductQuantity').val(currentVal);$('[js-formqtywp]').val(currentVal);
      return units;
    };
  }

  function round(value, decimals) {
    return Number(Math.round(value+'e'+decimals)+'e-'+decimals);
  }

  function getUnitPrice() {
    var priceText = $("[data-regular-price]").text()
    var currencySymbol = priceText.charAt(0)
    var price = priceText.match(/.*?[\$€](.*)\ */)
    if (priceText) {
      if(price == null) {
        var priceNice = priceText.split(currencySymbol);
        var floatPrice = parseFloat(priceNice[1])
        var roundedPrice = round(floatPrice, 2)
        return {currency: currencySymbol, price: roundedPrice}	
      }else {
        var floatPrice = parseFloat(price[1])
        var roundedPrice = round(floatPrice, 2)
        return {currency: currencySymbol, price: roundedPrice}
      }
    }
  }

  function calculate(units) {
    var units = units;
    var metres = (units);
    var yards = (units * 1.09361);

    var unitPrice = getUnitPrice();
    var totalPrice = (units * unitPrice.price * 2);

    $('#metre-result').text(metres.toFixed(2));
    $('#yard-result').text(yards.toFixed(2));

    $('#custom__totalPrice').text(unitPrice.currency + totalPrice.toFixed(2));
  }

  $('.qtyplus').on('click',function(e){
    e.preventDefault();
    var fieldName = $(this).attr('field');
    var currentVal = parseFloat($('input[name='+fieldName+']').val());
    if (!isNaN(currentVal)) {
      $('input[name='+fieldName+']').val(currentVal + 0.50);
    } else {
      $('input[name='+fieldName+']').val(0);
    }
    calculate(getUnits());
  });

  $('.qtyminus').on('click',function(e) {
    e.preventDefault();
    var fieldName = $(this).attr('field');
    var currentVal = parseFloat($('input[name='+fieldName+']').val());
    if (!isNaN(currentVal) && currentVal > 0) {
      $('input[name='+fieldName+']').val(currentVal - 0.50);
    } else {
      $('input[name='+fieldName+']').val(0);
    }
    calculate(getUnits());
  });

});